import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import { RotateLeft, RotateRight } from '@material-ui/icons';
import React from 'react';
import { useLocalization } from "../../hooks/index.js";
import { ROTATION_MODE } from "../../models/rotation-model.js";
import { RotateWidget } from "./rotate-widget.js";
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {},
    icon: {}
  });
});
export const RotateActivePagesWidget = props => {
  const localization = useLocalization();
  const classes = useStyles(props);

  const button = (direction, rotateDocument) => {
    const isLeft = direction === ROTATION_MODE.anticlockwise;
    return /*#__PURE__*/React.createElement(IconButton, {
      className: classes.iconButton,
      color: "inherit",
      title: isLeft ? localization.rotatePageLeft : localization.rotatePageRight,
      onClick: () => isLeft ? rotateDocument('left') : rotateDocument('right')
    }, isLeft ? /*#__PURE__*/React.createElement(RotateLeft, {
      className: classes.icon
    }) : /*#__PURE__*/React.createElement(RotateRight, {
      className: classes.icon
    }));
  };

  return /*#__PURE__*/React.createElement(RotateWidget, {
    renderButton: button,
    mode: props.mode,
    pages: "active"
  });
};
//# sourceMappingURL=rotate-active-pages.js.map